import { render } from "./MessagesPage.vue?vue&type=template&id=5f288386&scoped=true&ts=true"
import script from "./MessagesPage.vue?vue&type=script&lang=ts"
export * from "./MessagesPage.vue?vue&type=script&lang=ts"

import "./MessagesPage.vue?vue&type=style&index=0&id=5f288386&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f288386"]])

export default __exports__